import * as React from "react";
import { observer } from "mobx-react";
import {
  UserDataStoreContext,
  ModalEnum,
  ModalStoreContext,
  addUserModalStore,
} from "../../store";
import AddTaskIcon from "@mui/icons-material/AddTask";
import DatasetLinkedIcon from "@mui/icons-material/DatasetLinked";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import EditIcon from "@mui/icons-material/Edit";
import LogoutIcon from "@mui/icons-material/Logout";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";

const Nav = observer((props) => {
  const userDataStore = React.useContext(UserDataStoreContext);
  const modalStore = React.useContext(ModalStoreContext);

  let items = [
    {
      label: "Create Task",
      icon: <AddTaskIcon />,
      onClick: () => modalStore.setModal(ModalEnum.CREATE_TASK),
    },
  ];
  if (userDataStore.roles.includes("ROLE_ADMIN")) {
    items.push(
      {
        label: "Add Client",
        icon: <DatasetLinkedIcon />,
        onClick: () => modalStore.setModal(ModalEnum.ADD_CLIENT),
      },
      {
        label: "Edit Client",
        icon: <EditIcon />,
        onClick: () => modalStore.setModal(ModalEnum.EDIT_CLIENT),
      },
      {
        label: "Add User",
        icon: <PersonAddIcon />,
        onClick: () => {
          addUserModalStore.reset();
          modalStore.setModal(ModalEnum.ADD_USER);
        },
      },
      {
        label: "Edit User",
        icon: <ManageAccountsIcon />,
        onClick: () => {
          addUserModalStore.reset();
          addUserModalStore.setInEditMode(true);
          modalStore.setModal(ModalEnum.EDIT_USER);
        },
      },
    );
  }
  items.push({
    label: "Logout",
    icon: <LogoutIcon />,
    // Clears the backend SSO session and leaves for the sign-in screen
    onClick: () => userDataStore.logout(),
  });
  return (
    <List component="nav">
      <React.Fragment>
        {items.map((item) => (
          <ListItemButton key={item.label} onClick={item.onClick}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItemButton>
        ))}
      </React.Fragment>
    </List>
  );
});

export default Nav;
